<div class="kpi-card">
    <div class="kpi-icon" [style.background]="iconBg">
        <img [src]="icon" alt="">
    </div>
    <div class="kpi-body">
        <p class="kpi-label">{{label}}</p>
        <p class="kpi-value">{{value}}</p>
        <div class="kpi-change-row" *ngIf="changePct !== null || subLabel">
            <span class="kpi-change-text">{{subLabel || changeLabel}}</span>
            <span class="kpi-change" *ngIf="changePct !== null" [style.color]="changeColor">
                {{changePct >= 0 ? '+' : ''}}{{changePct}}%
                <img [src]="changeIcon" alt="" class="kpi-change-icon">
            </span>
        </div>
        <app-sparkline *ngIf="trend?.length" [data]="trend" [color]="trendColor"></app-sparkline>
    </div>
</div>
